<script lang="ts">
  import Input from '$shared/atoms/Input/Input.svelte';
  import { InputType } from '$shared/constants/InputType';

  interface Props {
    type?: InputType | string;
    label?: string;
    icon?: string;
    name?: string;
    value?: string;
    error?: string;
    placeholder?: string;
    disabled?: boolean;
    tabIndex?: any;
    required?: boolean;
    onblur?: (e: FocusEvent) => void;
    onfocus?: (e: FocusEvent) => void;
    onchange?: (e: Event) => void;
    oninput?: (value: string) => void;
  }

  let {
    type = InputType.Date,
    label = '',
    icon = '',
    name = '',
    value = '',
    error = '',
    placeholder = '',
    disabled = false,
    tabIndex = -1,
    required = true,
    onblur,
    onfocus,
    onchange,
    oninput
  }: Props = $props();

  const applyDateSeparator = (detail: { value: string }) => {
    let val = detail.value;
    if (val.length === 2 || val.length === 5) {
      val += '/';
    }
    oninput?.(val);
  };
</script>

<Input
  {type}
  {label}
  {icon}
  {name}
  {value}
  {error}
  {placeholder}
  {disabled}
  {tabIndex}
  {required}
  {onblur}
  {onchange}
  {onfocus}
  oninput={applyDateSeparator}
/>
